/*
 *
 * Do not edit directly
 * Generated on Mon, 24 Jun 2024 16:18:26 GMT
 *
 */


const theme = {
  appearances: { size: { type: 'variant', values: [ 'small' ] } },
  rules: [ { if: { size: 'small' }, tokens: { size: 24, thickness: 2 } } ],
  tokens: {
    fullScreenOverLayBackground: 'rgba(255, 255, 255, 0.97)',
    size: 48,
    thickness: 4
  }
}
export default theme
